import React from "react";
import ReactWOW from "react-wow";

const Training = ({ Message: msg }) => (
  <section id="training" className="white">
    <div className="container">
      <div className="section-title">
        <h2>{msg.trainingWorkshops}</h2>
        {/* <p>Register for the competition and you will receive updates on upcoming training workshops. Please note that only successfully registered teams will receive invitations for the training workshops.</p> */}
        <p>{msg.trainingDesc}</p>
        <p>{msg.trainingDesc2}</p>
      </div>
      {/* <div className="flex-box">
        <ReactWOW animation="fadeInUp" delay="0.1s">
          <div className="box box-2 text-left">
            <div className="content">
              <h3>
                Python Series: Data Analysis Training Workshop{" "}
                <span>By YiDu AI</span>
              </h3>
              <strong>Part 1:</strong>
              <p>Introduction to Big Data Analysis</p>
              <ul>
                <li>Overview of stock market data analysis with python</li>
                <li>Introduction to numpy array</li>
                <li>Pandas series and index object</li>
                <li>Pandas dataframe basics</li>
              </ul>
              <p>Data Manipulation with Pandas</p>
              <ul>
                <li>Pandas dataframe operation</li>
                <li>Advanced pandas dataframe</li>
              </ul>
              <strong>Part 2:</strong>
              <p>Data Visualisation and Regular Expression</p>
              <ul>
                <li>Data visualisation with matplotlib</li>
                <li>Advanced visualisation with seaborn</li>
                <li>Regular expression fundamentals</li>
              </ul>
              <p>
                (Priority will be given to the participants in the
                Undergraduates and Open Category.)
              </p>
              <p
                style={{
                  background: "rgba(0,0,0,0.05)",
                  padding: "8px 12px",
                  textAlign: "center",
                  color: "#EE4D2D"
                }}
              >
                Registration is closed
              </p>
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.2s">
          <div className="box box-2 text-left">
            <div className="content">
              <h3>
                Python Meets Math for Beginners <span>By Coding Lab</span>
              </h3>
              <ul>
                <li>Introduction to Python</li>
                <li>Booleans and Conditionals</li>
                <li>While Loops</li>
                <li>Functions</li>
                <li>Modules and Libraries</li>
              </ul>
              <p
                style={{
                  background: "rgba(0,0,0,0.05)",
                  padding: "8px 12px",
                  textAlign: "center",
                  color: "#EE4D2D"
                }}
              >
                Registration is closed
              </p>
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.3s">
          <div className="box box-2 text-left">
            <div className="content">
              <h3>
                Training Workshop on Python and Chatbot{" "}
                <span>By Lithan Academy</span>
              </h3>
              <strong>Part 1:</strong>
              <ul>
                <li>Basics Introduction to Python</li>
                <li>Functions in Python</li>
                <li>Demo: Basic Python Program in Jupyter Notebook</li>
              </ul>
              <strong>Part 2:</strong>
              <ul>
                <li>Conditionals in Python</li>
                <li>Nesting and Loops in Python</li>
                <li>Introduction to chatbot and its types/advantages </li>
                <li>
                  Demo: Chatbot Program using conditionals and Functions in
                  Python
                </li>
                <li>
                  Demo: Chatbot Program using conditionals and Looping in Python
                </li>
              </ul>
              <strong>Part 3:</strong>
              <ul>
                <li>Understanding Text analytics</li>
                <li>Introduction to NLTK</li>
                <li>Demo: Simple pair reflection Chatbot using NLTK</li>
              </ul>
              <strong>Part 4:</strong>
              <ul>
                <li>Introduction to AI, ML and DL</li>
                <li>Chatbot using Machine Learning algorithms</li>
                <li>Demo: Chatbot using NLTK</li>
              </ul>
              <p
                style={{
                  background: "rgba(0,0,0,0.05)",
                  padding: "8px 12px",
                  textAlign: "center",
                  color: "#EE4D2D"
                }}
              >
                Registration is closed
              </p>
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.4s">
          <div className="box box-2 text-left">
            <div className="content">
              <h3>
                Training Workshop on Thinking Like a Data Scientist{" "}
                <span>By UpLevel</span>
              </h3>
              <strong>Part 1: Preparing of Data</strong>
              <ul>
                <li>Where and how to get data</li>
                <li>Cleaning and wrangling data</li>
                <li>Figuring out data</li>
              </ul>
              <strong>Part 2: Building Models</strong>
              <ul>
                <li>Coming up with a game plan</li>
                <li>Derive information and relationships</li>
                <li>Improving and deploying models</li>
              </ul>
              <strong>Part 3: Analysis Finishes</strong>
              <ul>
                <li>Contextualizing what has been learned</li>
                <li>Tips and tricks for presentation</li>
              </ul>
              <p
                style={{
                  background: "rgba(0,0,0,0.05)",
                  padding: "8px 12px",
                  textAlign: "center",
                  color: "#EE4D2D"
                }}
              >
                Registration is closed
              </p>
            </div>
          </div>
        </ReactWOW>
      </div> */}
    </div>
  </section>
);

export default Training;
